import { bsc } from 'wagmi/chains';
const specific_config = process.env.ENV === 'prod' ? require('./config.prod') : require('./config.dev');
export const environment = specific_config.ENVIRONMENT;
export const projectId = specific_config.PROJECT_ID;
export const collectionId = specific_config.COLLECTION_ID;
export const vestingContract = specific_config.VESTING_CONTRACT;
export const apiBaseUrl = specific_config.API;
export const playstoreUrl =
    'https://play.google.com/store/apps/details?id=com.vivoka.application.tada.prod&pcampaignid=web_share';
export const appStoreUrl = 'https://apps.apple.com/fr/app/ta-da/id6452014754';
export const multiversXDepositPool =
    'https://xexchange.com/pools/erd1qqqqqqqqqqqqqpgqamlvh7su5925r7djmd36xd93gylfym9j2jpsdya7mj?firstToken=WEGLD-bd4d79&secondToken=TADA-5c032c';
export const bscDepositPool = 'https://pancakeswap.finance/info/pairs/0xde4ee88b8b437bbce788083a6def01f8335d3f36';
export const supportedChains = [bsc];
export const web3modalMetadata = {
    name: 'Ta-da Account Portal',
    description: 'Connect your wallet to Ta-da Account Portal',
    url: window.location.origin,
    icons: [window.location.origin + '/android-chrome-192x192.png'],
};

export const mvxApiUrl = specific_config.MULTIVERSX_API_URL;
export const mvxExplorerUrl = specific_config.MULTIVERSX_EXPLORER_URL;
